import React from 'react';
import './AboutUsSection.css';
// import aboutUsImage from '../../assets/team-short.png';
import aboutUsImage from '../../assets/team/Meeting-bro.webp';
import ProjektanfrageButton from '../../components/ProjectRequest/Projektanfrage';

const AboutUsSection = () => {
  return (
    <section className="about-us-section">
      <div className="about-us-container">
        <div className="about-us-image">
          <img src={aboutUsImage} alt="IT-Experten der Universität Bonn bei der Arbeit" />
        </div>

        <div className="about-us-content">
          <h2 className="about-us-title">Nexite IT</h2>
          <div className="about-us-text">
            <p>
              Nexite IT setzt sich aus einem Zusammenschluss studierter IT-Freiberufler 
              der Universität Bonn zusammen. Gemeinsam entwickeln wir seit 6+ Jahren 
              qualitativ hochwertige Softwarelösungen für Web, Apps und digitale Transformation.
            </p>
            <p>
              Unsere Stärken:
              <br/>
              ✓ Agile Entwicklung skalierbarer Systeme
              <br/>
              ✓ Individuelle Prozessoptimierung
              <br/>
              ✓ Nahtlose Nutzererlebnisse
              <br/><br/>
              Als Team aus 7 Universitätsabsolventen kombinieren wir wissenschaftliche Expertise 
              mit praxiserprobten Methoden - lokal wie international.
            </p>
          </div>
          <div className="projektanfrage-button-container">
            <ProjektanfrageButton />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;